import { StreamChat, type User } from 'stream-chat';
import { ContainerInstance, Service } from 'typedi';
import { type AppEnvironment } from '../config/app-environment';
import { EnvironmentService } from '../config/environment.service';

@Service()
export class StreamService {
  readonly client: StreamChat;

  isConnected: boolean = false;

  constructor(container: ContainerInstance) {
    const { environment } = container.get(EnvironmentService<AppEnvironment>);
    this.client = StreamChat.getInstance(
      environment.VITE_APP_PRAYER_STREAM_STREAM_API_KEY,
    );
  }

  async connectUser(user: User, token: string): Promise<void> {
    if (!this.isConnected) {
      await this.client.connectUser(user, token);
      this.isConnected = true;
    }
  }

  async disconnect(): Promise<void> {
    if (this.isConnected) {
      await this.client.disconnectUser();
      this.isConnected = false;
    }
  }

  generateDevToken(id: string): string {
    return this.client.devToken(id);
  }

  isUserConnected(): boolean {
    return this.isConnected;
  }
}
